import React, { useState } from "react";
import Rollo from "./Rollo";
import ScannerModal, { DecodedResult } from "../ScannerModal";
import SeleccionRolloModal from "./SeleccionRolloModal";
import * as _ from "lodash";

interface ListadoRollosProps {
  ingreso: any;
  rollos: any;
  setDirty: (isDirty: boolean) => void;
}

export type TRollo = {
  rollo_id: string;
};

type Seleccion = {
  key: number;
  value: string;
};

export const ListadoRollos = (props: ListadoRollosProps) => {
  const { ingreso, rollos, setDirty } = props;
  const [isScanning, setScanning] = useState(false);
  const [showSeleccion, setShowSeleccion] = useState(false);
  const [rolloSelecionado, setRolloSeleccionado] = useState<Seleccion|undefined>(undefined);

  const scannerToggle = () => {
    setScanning(!isScanning);
  };

  const toggleSeleccion = () => {
    setShowSeleccion(!showSeleccion);
  };

  const mostrarSeleccion = (rolloId: number) => {
    const rollo = rollos[rolloId];
    console.log("El rollo: ", rollo);
    setRolloSeleccionado({ key: rolloId, value: rollo?.rollo_id });
    setShowSeleccion(true);
    setScanning(false);
  };

  const displayWarningMessage = (message: string) => {
    alert(message);
  };

  const onScanResult = (result: string, decodedResult: DecodedResult) => {
    console.log("Decoded text:", result);
    if (decodedResult.result.format.formatName !== "DATA_MATRIX") {
      displayWarningMessage(
        `El código escaneado no es válido. Se esperaba un tipo "DATA_MATRIX". Valor ingresado: ${result}.`
      );
      return;
    }
    // TODO: validate result as a module id
    if (isDuplicateCode(result)) {
      console.log("Rollo ya escaneado");
      displayWarningMessage(
        `No es posible escanear un rollo repetido: ${result}`
      );
      return;
    }
    console.log("ROLLO:", rollos[rolloSelecionado!.key]);
    rollos[rolloSelecionado!.key] = { rollo_id: result };
    setDirty(true);
    setScanning(false);
    setShowSeleccion(false);
    setRolloSeleccionado(undefined);
  };
  const debouncedResult = _.debounce(onScanResult, 500);

  const onInputManual = (valorManual: string) => {
    console.log("ROLLO:", rollos[rolloSelecionado!.key]);
    console.log("Valor manual:", valorManual);
    if (isDuplicateCode(valorManual)) {
      console.log("Rollo ya escaneado");
      displayWarningMessage(
        `No es posible escanear un rollo repetido: ${valorManual}`
      );
      return;
    }
    console.log("ROLLO:", rollos[rolloSelecionado!.key]);
    rollos[rolloSelecionado!.key] = { rollo_id: valorManual };
    setDirty(true);
    setScanning(false);
    setShowSeleccion(false);
    setRolloSeleccionado(undefined);
  };

  const isDuplicateCode = (code: string) => {
    console.log("ROLLO:", rollos);
    return rollos.find((rollo: any) => {
      console.log(`rollo = ${rollo?.rollo_id}, input = ${code}`);
      return rollo?.rollo_id === code;
    });
  };

  return (
    <>
      <hr className="mg-y-30" />
      <label className="az-content-label tx-13 mg-b-20">ROLLOS</label>
      <div>
        <ul>
          {(() => {
            const listItems = [];
            for (let i = 0; i < ingreso.cantidad_rollos; i++) {
              const rollo = rollos[i];
              // console.log("Iter rollos:", rollo);
              const value = rollo ? rollo.rollo_id : "";

              listItems.push(
                <Rollo
                  key={i}
                  index={i}
                  value={value}
                  onClick={(e, rolloId) => {
                    mostrarSeleccion(rolloId);
                  }}
                />
              );
            }

            return listItems;
          })()}
        </ul>
      </div>
      <SeleccionRolloModal
        showSeleccion={showSeleccion}
        onClickScan={() => setScanning(true)}
        toggleSeleccion={toggleSeleccion}
        onClickManual={onInputManual}
        seleccion={rolloSelecionado}
      />
      <ScannerModal
        showScanner={isScanning}
        scannerToggle={scannerToggle}
        onScanResult={(value, decodedResult) => {
          console.log("Read:", value);
          debouncedResult(value, decodedResult);
        }}
      />
    </>
  );
};
